<template functional>
  <svg
    width="36.00000000000001"
    height="36.00000000000001"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Created with Method Draw - http://github.com/duopixel/Method-Draw/ -->

    <g>
      <title>background</title>
      <rect
        id="canvas_background"
        fill="none"
        height="38"
        width="38"
        y="-1"
        x="-1"
      />
    </g>
    <g>
      <g id="Schwein">
        <g id="svg_9">
          <path
            id="svg_10"
            d="m23.975,16.109c-0.737,0 -1.333,-0.597 -1.333,-1.333c0,-0.737 0.596,-1.334 1.333,-1.334c0.483,0 0.899,0.258 1.136,0.641c-0.12,-0.07 -0.258,-0.113 -0.406,-0.113c-0.443,0 -0.808,0.361 -0.808,0.806c0,0.445 0.36,0.805 0.808,0.805c0.148,0 0.286,-0.043 0.406,-0.113c-0.237,0.383 -0.655,0.641 -1.136,0.641m3.991,-0.863l-0.518,0c-0.12,-0.36 -0.265,-0.687 -0.43,-0.994c-0.443,-0.831 -1.062,-1.583 -1.854,-2.255c0.141,-0.205 0.262,-0.409 0.358,-0.615c0.269,-0.53 0.437,-1.075 0.492,-1.621c0.065,-0.555 0.022,-1.087 -0.124,-1.581c-0.041,-0.136 -0.159,-0.233 -0.302,-0.248c-0.146,-0.017 -0.278,0.059 -0.347,0.184c-0.149,0.277 -0.363,0.529 -0.645,0.748c-0.281,0.221 -0.61,0.397 -0.979,0.519c-0.39,0.13 -0.799,0.194 -1.222,0.194l-4.271,0c-1.292,0 -2.548,0.201 -3.732,0.596c-1.145,0.383 -2.177,0.933 -3.062,1.633c-0.896,0.706 -1.598,1.528 -2.085,2.446c-0.52,0.958 -0.773,1.976 -0.773,3.026c0,0.686 -0.558,1.244 -1.24,1.244c-0.513,0 -0.927,-0.415 -0.927,-0.925c0,-0.369 0.302,-0.668 0.669,-0.668c0.26,0 0.466,0.209 0.466,0.465c0,0.194 0.158,0.352 0.354,0.352c0.19,0 0.351,-0.157 0.351,-0.352c0,-0.645 -0.521,-1.168 -1.168,-1.168c-0.757,0 -1.373,0.615 -1.373,1.372c0,0.898 0.731,1.628 1.63,1.628c0.553,0 1.047,-0.231 1.397,-0.599c0.127,0.574 0.327,1.137 0.616,1.679c0.354,0.666 0.838,1.292 1.428,1.863l0,2.904c-0.103,0.325 0.013,0.694 0.315,1.049c0.272,0.316 0.688,0.599 1.164,0.796c0.42,0.174 0.847,0.266 1.229,0.266c0.541,0 0.945,-0.189 1.123,-0.521l1.813,-1.819c1.191,0.18 2.406,0.18 3.604,0l1.818,1.819c0.179,0.331 0.582,0.521 1.125,0.521c0.387,0 0.812,-0.092 1.229,-0.266c0.479,-0.197 0.893,-0.48 1.163,-0.796c0.312,-0.355 0.421,-0.724 0.322,-1.049l0,-2.905c0.59,-0.571 1.065,-1.197 1.425,-1.862c0.081,-0.151 0.159,-0.31 0.229,-0.471l1.037,0c0.11,0 0.226,-0.057 0.287,-0.151c0.486,-0.703 0.758,-1.634 0.758,-2.619c0.019,-1.021 -0.581,-1.819 -1.35,-1.819"
            fill="#D14D8F"
          />
          <path
            id="svg_11"
            d="m18.142,1.874c-8.97,0 -16.267,7.296 -16.267,16.264c0,8.97 7.297,16.265 16.267,16.265s16.266,-7.295 16.266,-16.265c0,-8.968 -7.296,-16.264 -16.266,-16.264m0,33.403c-9.449,0 -17.142,-7.688 -17.142,-17.139c0,-9.45 7.688,-17.138 17.142,-17.138s17.141,7.688 17.141,17.138c0,9.45 -7.69,17.139 -17.141,17.139"
            fill="#D14D8F"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CharmPig",
};
</script>
